module.exports = __webpack_public_path__ + "img/sfdw_hover.510b32e8.png";